const ClassHierarchy =[
  {
    "mainClass": "home",
    "subClass": "roommate",
  },
  {
    "mainClass": "career",
    "subClass": "job",
  },
  {
    "mainClass": "career",
    "subClass": "careerRelated",
  },
  {
    "mainClass": "career",
    "subClass": "manager",
  },
  {
    "mainClass": "career",
    "subClass": "college"
  },
  {
    "mainClass": "job",
    "subClass": "manager",
  },
  { "mainClass": "car",
    "subClass": "car-warranty"
  },
  { "mainClass": "home",
    "subClass": "home-warranty"
  }
  
];

export default ClassHierarchy;